import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Switch } from '@mui/material';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useThemeMode } from 'contexts/ThemeModeContext';

const defaultStockTheme = createTheme();

const DarkModeToggle = ({ size = 'small', sx, ...props }) => {
	const parentTheme = useTheme();
	const { mode, toggleTheme } = useThemeMode();

	// resets custom MuiSwitch theme overrides (e.g. from Launchpad theme) so the toggle retains stock MUI switch styling
	const switchTheme = useMemo(() => {
		const base =
			parentTheme && Object.keys(parentTheme).length > 0
				? parentTheme
				: defaultStockTheme;
		return {
			...base,
			components: {
				...base.components,
				MuiSwitch: undefined,
			},
		};
	}, [parentTheme]);

	return (
		<ThemeProvider theme={switchTheme}>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: 0.5,
					...sx,
				}}
				{...props}
			>
				<LightModeOutlinedIcon
					sx={{
						fontSize: 16,
						color: mode === 'light' ? 'text.primary' : 'text.tertiary',
					}}
				/>
				<Switch
					checked={mode === 'dark'}
					onChange={toggleTheme}
					slotProps={{ input: { 'aria-label': 'toggle dark mode' } }}
					size={size}
				/>
				<DarkModeOutlinedIcon
					sx={{
						fontSize: 16,
						color: mode === 'dark' ? 'text.primary' : 'text.tertiary',
					}}
				/>
			</Box>
		</ThemeProvider>
	);
};

DarkModeToggle.propTypes = {
	size: PropTypes.oneOf(['small', 'medium']),
	sx: PropTypes.object,
};

export default DarkModeToggle;
